<!-- MAIN NAVBAR -->
<nav class="navbar navbar-expand-lg">
  <div class="container-fluid d-flex justify-content-between align-items-center">

    <!-- ==========================================
         DESKTOP & TABLET LAYOUT
         ========================================== -->
    <!-- ==========================================
         DESKTOP & TABLET LAYOUT (WESTSIDE STYLE)
         ========================================== -->
    <div class="d-none d-lg-flex flex-column w-100">

      <!-- TOP ROW: Logo + Search + Actions -->
      <div class="top-row d-flex justify-content-between align-items-center px-4 py-3">
        <!-- LEFT: Logo -->
        <a class="navbar-brand m-0" routerLink="/">
          <img src="../../../assets/img/budget-logo.png" class="logo" alt="Budget Bazaar" />
        </a>

        <!-- CENTER: Outlined Search Pill -->
        <div class="search-wrapper m-0">
          <div class="search-bar static-pill">
            <i class="bi bi-search search-bar-icon"></i>
            <input type="text" class="search-input" placeholder="Search" [value]="searchQuery"
              (input)="onSearchInput($event)" (keydown.escape)="closeSearch()" autocomplete="off" />
            <button class="search-close-btn" *ngIf="searchQuery"
              (click)="searchQuery=''; closeSearch(); $event.stopPropagation()">
              <i class="bi bi-x"></i>
            </button>
          </div>

          <!-- Search Results Dropdown -->
          <div class="search-dropdown clean-dropdown"
            *ngIf="(showSearchResults || isSearching || (searchQuery.length >= 2 && !isSearching && searchResults.length === 0))">
            <div class="search-loading" *ngIf="isSearching">
              <div class="search-spinner"></div>
              <span>Searching...</span>
            </div>
            <div *ngIf="!isSearching && searchResults.length > 0">
              <a class="search-result-item clean-item" *ngFor="let product of searchResults"
                (click)="navigateToProduct(product)">
                <div class="search-result-img">
                  <img [src]="getSearchImageUrl(product)" alt="" (error)="onImageError($event)" />
                </div>
                <div class="search-result-info">
                  <span class="search-result-name">{{ product.productName }}</span>
                  <span class="search-result-category" *ngIf="product.categoryDetails?.categoryName">
                    {{ product.categoryDetails.categoryName }}
                  </span>
                  <span class="search-result-price">₹{{ getProductPrice(product) }}</span>
                </div>
              </a>
            </div>
            <div class="search-no-results"
              *ngIf="!isSearching && searchQuery.length >= 2 && searchResults.length === 0">
              <span>No products found for "{{ searchQuery }}"</span>
            </div>
          </div>
        </div>

        <!-- RIGHT: Minimal Actions -->
        <div class="d-flex align-items-center gap-4 premium-actions">
          <!-- Instagram Link -->
          <a href="https://www.instagram.com/its_budget_bazaar?igsh=MWExdjB0eXJ5cDNhNw==" target="_blank"
            class="premium-action-icon" title="Instagram">
            <i class="bi bi-instagram"></i>
          </a>

          <!-- YouTube Dropdown -->
          <div class="yt-dropdown-wrapper">
            <a class="premium-action-icon" role="button" title="Our YouTube Channels">
              <i class="bi bi-youtube"></i>
            </a>
            <div class="yt-dropdown-panel clean-panel">
              <a href="https://youtube.com/@jointsareecollection?si=CQ6cIM-XsMeDbkMp" target="_blank"
                class="yt-drop-item">Joint Saree</a>
              <a href="https://youtube.com/@beautybloomboutique?si=KVxBSxKv4ji6J4Tf" target="_blank"
                class="yt-drop-item">Full Saree</a>
              <a href="https://youtube.com/@onlinebazaartamil?si=JTZjyGf5R2t4QcTd" target="_blank"
                class="yt-drop-item">Dresses</a>
            </div>
          </div>

          <a class="premium-action-icon position-relative" *ngIf="user && user.userType === 'USER'"
            [routerLink]="['/cart']" title="Cart">
            <i class="bi bi-bag"></i>
            <span *ngIf="cartCount > 0" class="cart-dot"></span>
          </a>
          <a class="premium-action-icon" *ngIf="user" [routerLink]="['/my-orders']" title="Orders">
            <i class="bi bi-box-seam"></i>
          </a>
          <a class="premium-action-icon" *ngIf="!user" [routerLink]="['/customer-login']" title="Sign In">
            <i class="bi bi-person"></i>
          </a>
          <a class="premium-action-icon" *ngIf="user" (click)="logout()" style="cursor:pointer" title="Sign Out">
            <i class="bi bi-box-arrow-right"></i>
          </a>
        </div>
      </div>

      <!-- BOTTOM ROW: Categories -->
      <div class="bottom-row w-100 pb-3 d-flex justify-content-center position-relative" *ngIf="!hideCategoryBar">
        <div class="category-links-wrapper">

          <div class="category-link-item" *ngFor="let cat of visibleCategories">
            <span class="cat-label" (click)="navigateToCategory(cat.categoryId)">
              {{ cat.categoryName }} <i class="bi bi-chevron-down ms-1" style="font-size: 10px;"
                *ngIf="cat.subCategories?.length"></i>
            </span>
            <!-- Minimal Subcategory Dropdown -->
            <div class="clean-sub-dropdown" *ngIf="cat.subCategories?.length">
              <a class="clean-sub-item" *ngFor="let sub of cat.subCategories"
                (click)="navigateToSubCategory(cat.categoryId, sub.subCategoryId)">
                {{ sub.subCategoryName }}
              </a>
            </div>
          </div>

          <!-- MORE Categories Dropdown -->
          <div class="category-link-item view-more-item position-static" *ngIf="moreCategories.length > 0">
            <span class="cat-label">
              View More <i class="bi bi-chevron-down ms-1" style="font-size: 10px;"></i>
            </span>
            <div class="clean-sub-dropdown more-dropdown shadow">
              <div class="more-cat-group" *ngFor="let moreCat of moreCategories">
                <a class="more-cat-title" (click)="navigateToCategory(moreCat.categoryId)">
                  {{ moreCat.categoryName }}
                </a>
                <a class="clean-sub-item indented" *ngFor="let sub of moreCat.subCategories"
                  (click)="navigateToSubCategory(moreCat.categoryId, sub.subCategoryId)">
                  {{ sub.subCategoryName }}
                </a>
              </div>
            </div>
          </div>

        </div>
      </div>

    </div>

    <!-- ==========================================
         MOBILE LAYOUT (Header)
         ========================================== -->
    <div class="d-flex d-lg-none w-100 justify-content-between align-items-center">
      <!-- Mobile Logo -->
      <a class="navbar-brand m-0" routerLink="/">
        <img src="../../../assets/img/budget-logo.png" class="logo" alt="Budget Bazaar" />
      </a>

      <!-- Mobile: Search + Toggle -->
      <div class="d-flex align-items-center gap-2">
        <button class="mobile-search-toggle" (click)="toggleSearch()">
          <i class="bi bi-search"></i>
        </button>
        <button class="navbar-toggler d-lg-none border-0" type="button" data-bs-toggle="offcanvas"
          data-bs-target="#mobileMenu">
          <i class="bi bi-list fs-2"></i>
        </button>
      </div>

    </div>
  </div>
</nav>

<!-- Mobile Search Overlay -->
<div class="mobile-search-overlay d-lg-none" *ngIf="searchOpen" (click)="closeSearch()"></div>
<div class="mobile-search-wrapper d-lg-none" *ngIf="searchOpen">
  <div class="mobile-search-bar">
    <i class="bi bi-search mobile-search-icon"></i>
    <input #searchInput type="text" class="mobile-search-input" placeholder="Search products..." [value]="searchQuery"
      (input)="onSearchInput($event)" (keydown.escape)="closeSearch()" autocomplete="off" />
    <button class="mobile-search-close" (click)="closeSearch()">
      <i class="bi bi-x fs-5"></i>
    </button>
  </div>

  <!-- Mobile Search Results -->
  <div class="mobile-search-results"
    *ngIf="showSearchResults || isSearching || (searchQuery.length >= 2 && !isSearching && searchResults.length === 0)">
    <div class="search-loading" *ngIf="isSearching">
      <div class="search-spinner"></div>
      <span>Searching...</span>
    </div>
    <div *ngIf="!isSearching && searchResults.length > 0">
      <a class="search-result-item" *ngFor="let product of searchResults"
        (click)="navigateToProduct(product)">
        <div class="search-result-img">
          <img [src]="getSearchImageUrl(product)" alt="" (error)="onImageError($event)" />
        </div>
        <div class="search-result-info">
          <span class="search-result-name">{{ product.productName }}</span>
          <span class="search-result-category" *ngIf="product.categoryDetails?.categoryName">
            {{ product.categoryDetails.categoryName }}
          </span>
          <span class="search-result-price">₹{{ getProductPrice(product) }}</span>
        </div>
        <i class="bi bi-arrow-right search-result-arrow"></i>
      </a>
    </div>
    <div class="search-no-results" *ngIf="!isSearching && searchQuery.length >= 2 && searchResults.length === 0">
      <i class="bi bi-search"></i>
      <span>No products found for "{{ searchQuery }}"</span>
    </div>
  </div>
</div>

<!-- ================= PREMIUM MOBILE MENU (WESTSIDE STYLE) ================= -->

<div class="offcanvas offcanvas-start clean-mobile-menu" tabindex="-1" id="mobileMenu" #mobileMenu>

  <!-- Clean Header -->
  <div class="mobile-header">
    <img src="../../../assets/img/budget-logo.png" class="mobile-logo" />
    <button type="button" class="mobile-close-btn" data-bs-dismiss="offcanvas">
      <i class="bi bi-x-lg"></i>
    </button>
  </div>

  <div class="mobile-body overflow-auto">
    <!-- Categories List -->
    <div class="mobile-list-item-group" *ngFor="let cat of categoryDetails">
      <div class="mobile-list-item" (click)="handleMobileCategoryClick(cat)">
        <span class="category-name">{{ cat.categoryName }}</span>
        <i class="bi" [ngClass]="openedCategory === cat ? 'bi-chevron-up' : 'bi-chevron-down'"
          *ngIf="cat.subCategories?.length"></i>
      </div>
      <!-- Subcategories -->
      <div class="mobile-sub-list" *ngIf="openedCategory === cat && cat.subCategories?.length">
        <a class="mobile-sub-item" (click)="navigateToCategory(cat.categoryId); closeOffcanvas()">
          View All
        </a>
        <a class="mobile-sub-item" *ngFor="let sub of cat.subCategories"
          (click)="navigateToSubCategory(cat.categoryId, sub.subCategoryId); closeOffcanvas()">
          {{ sub.subCategoryName }}
        </a>
      </div>
    </div>

    <div class="mobile-divider"></div>

    <!-- YouTube Links -->
    <a class="mobile-list-item border-0 pb-1" href="https://youtube.com/@jointsareecollection?si=CQ6cIM-XsMeDbkMp"
      target="_blank">Joint Saree (YouTube)</a>
    <a class="mobile-list-item border-0 py-1" href="https://youtube.com/@beautybloomboutique?si=KVxBSxKv4ji6J4Tf"
      target="_blank">Full Saree (YouTube)</a>
    <a class="mobile-list-item border-0 pt-1" href="https://youtube.com/@onlinebazaartamil?si=JTZjyGf5R2t4QcTd"
      target="_blank">Dresses (YouTube)</a>

    <div class="mobile-divider"></div>

    <!-- Quick Actions -->
    <a class="mobile-list-item" *ngIf="user && user.userType === 'USER'" [routerLink]="['/cart']"
      (click)="closeOffcanvas()">
      <div class="d-flex align-items-center gap-2">
        <i class="bi bi-bag"></i> Cart
      </div>
      <span *ngIf="cartCount > 0">({{ cartCount }})</span>
    </a>
    <a class="mobile-list-item" *ngIf="user" [routerLink]="['/my-orders']" (click)="closeOffcanvas()">
      <div class="d-flex align-items-center gap-2">
        <i class="bi bi-box-seam"></i> Orders
      </div>
    </a>
    <a class="mobile-list-item" *ngIf="!user" [routerLink]="['/customer-login']" (click)="closeOffcanvas()">
      <div class="d-flex align-items-center gap-2">
        <i class="bi bi-person"></i> Sign in
      </div>
    </a>
    <a class="mobile-list-item text-danger" *ngIf="user" (click)="logout(); closeOffcanvas()">
      <div class="d-flex align-items-center gap-2">
        <i class="bi bi-box-arrow-right"></i> Sign out
      </div>
    </a>
  </div>

</div>